import React, { useCallback, useRef, useState } from "react";
import cx from "classnames";
import { Input, Tooltip } from "reactstrap";
import { useClickOutside, useTranslate } from "hooks";
import { useCurrentQuestionnaire, useWizardActions } from "stores/wizardStore";
import { getAnswersFromValues } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardQuestionnaire/questionnaireHelpers";
import s from "../WizardComponent.module.scss";

const isStringOnlyWhitespace = (str) => /^\s*$/.test(str);

export const WizardEditableTitle = ({
  title,
  zoneId,
  inputClassNames,
  handleToggleEditMode,
}) => {
  const translate = useTranslate();
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState(title);
  const [showTooltip, setShowTooltip] = useState(false);

  const { updateWizardStepQuestionnaire } = useWizardActions();
  const currentQuestionnaire = useCurrentQuestionnaire();
  const { questions } = currentQuestionnaire;

  const handleInputChange = useCallback((e) => {
    setInputValue(e.target.value);
    setShowTooltip(false);
  }, []);

  const handleClickOutside = useCallback(() => {
    if (inputValue.length < 4 || isStringOnlyWhitespace(inputValue)) {
      setShowTooltip(true);
      return;
    }
    handleToggleEditMode();
    updateWizardStepQuestionnaire({
      questionnaire: [
        {
          title: inputValue,
          questions: getAnswersFromValues(questions, []),
        },
      ],
      id: zoneId,
    });
  }, [
    inputValue,
    handleToggleEditMode,
    updateWizardStepQuestionnaire,
    questions,
    zoneId,
  ]);

  useClickOutside(inputRef, () => {
    handleClickOutside();
  });

  const handleInputKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        handleClickOutside();
      }
    },
    [handleClickOutside],
  );

  return (
    <div className="position-relative d-flex align-items-center" ref={inputRef}>
      <Input
        id={`zone-title-input-id_${zoneId}`}
        className={inputClassNames}
        type="text"
        bsSize="sm"
        value={inputValue}
        onChange={handleInputChange}
        maxLength={30}
        onKeyDown={handleInputKeyDown}
      />
      <Tooltip
        isOpen={showTooltip}
        target={() => inputRef.current}
        placement="right"
      >
        {translate("WIZARD_ZONE_NAME_LENGTH_HINT")}
      </Tooltip>
      <div
        className={cx(s.inputLengthLabel, "text-gray-400 d-flex flex-nowrap")}
      >
        <span className="fw-bolder">{inputValue.length}</span>
        <span>&nbsp;/ {30}</span>
      </div>
    </div>
  );
};
